export const PIPE_DATA_REPORT_LARGE_SELECTION_THRESHOLD = 50;
export const PIPE_COMPATIBILITY_REPORT_LARGE_SELECTION_THRESHOLD = 10;

export function isLargePipeDataSelection(pipeCount: number): boolean {
  return pipeCount > PIPE_DATA_REPORT_LARGE_SELECTION_THRESHOLD;
}

export function isLargeCompatibilitySelection(pipeCount: number): boolean {
  return pipeCount > PIPE_COMPATIBILITY_REPORT_LARGE_SELECTION_THRESHOLD;
}

export function buildPipeDataLargeSelectionDescription(
  pipeCount: number,
  loginEmail: string
): string {
  return `You selected ${pipeCount} pipes . Pipe data report generation may take longer than usual. Once the report is ready, it will be sent to your  email (${loginEmail})  when the report is ready..`;
}

export function buildCompatibilityLargeSelectionDescription(
  pipeCount: number,
  loginEmail: string
): string {
  return `You selected ${pipeCount} pipes. Pipe compatibility report generation may take longer than usual. We will notify you at your  email (${loginEmail}) when the report is ready.`;
}
